import Vue from 'vue'
import VueRouter from 'vue-router'
import AppLayout from '../layouts/MembersOnly.vue'
import Login from '../components/pages/Login.vue'
import Home from '../components/pages/Home.vue'
import ImportUpload from '../components/pages/ImportUpload.vue'
import ImportEntries from '../components/pages/ImportEntries.vue'
import ImportJournal from '../components/pages/ImportJournal.vue'
import ImportExportParam from '../components/pages/ImportExportParam.vue'
import History from '../components/pages/History.vue'
import Arap from '../components/pages/Arap.vue'
import ArapUpload from '../components/pages/ArapUpload.vue'
import ArapTransfer from '../components/pages/ArapTransfer.vue'
import ArapPersAcct from '../components/pages/ArapPersAcct.vue'
import Config from '../components/pages/Config.vue'
import ConfigUser from '../components/pages/ConfigUser.vue'
import ConfigClient from '../components/pages/ConfigClient.vue'
import ConfigClientParam from '../components/pages/ConfigClientParam.vue'
import ConfigUserClient from '../components/pages/ConfigUserClient.vue'
import NoClientSelected from '../components/pages/ErrorNoClientSelected.vue'
import PageNotFound from '../components/pages/PageNotFound.vue'
import axios from 'axios'
import store from '../store.js'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: __dirname,
  routes: [
    {
      path: '/',
      redirect: '/home',
      meta: { requiresAuth: false, title: 'Übersicht' }
    },
    {
      path: '/login',
      component: Login,
      meta: { requiresAuth: false, title: 'Login' }
    },
    {
      path: '/home',
      component: AppLayout,
      meta: { requiresAuth: true, title: 'Übersicht' },
      children: [
        {
          path: '',
          component: Home,
          meta: { title: 'Übersicht' }
        },
        {
          path: 'import/upload',
          component: ImportUpload,
          meta: { requiresClientSelection: true, title: 'Import Upload' }
        },
        {
          path: 'import/entries',
          component: ImportEntries,
          meta: { requiresClientSelection: true, title: 'Kontierung' }
        },
        {
          path: 'import/journal',
          component: ImportJournal,
          meta: { requiresClientSelection: true, title: 'Journal-Kontierung' }
        },
        {
          path: 'import/parameter',
          component: ImportExportParam,
          meta: { requiresClientSelection: true, title: 'Parameter' }
        },
        {
          path: 'history',
          component: History,
          meta: { requiresClientSelection: true, title: 'History' }
        },
        {
          path: 'arap',
          component: Arap,
          meta: { requiresClientSelection: true, title: 'Offene Posten' }
        },
        {
          path: 'arap/processing',
          component: ArapUpload,
          meta: { requiresClientSelection: true, title: 'Dokumente verarbeiten' }
        },
        {
          path: 'arap/transfer',
          component: ArapTransfer,
          meta: { requiresClientSelection: true, title: 'Dokumente transferieren' }
        },
        {
          path: 'arap/pa',
          component: ArapPersAcct,
          meta: { requiresClientSelection: true, title: 'Personenkonto bearbeiten' }
        },
        {
          path: 'arap/document/edit/:id',
          component: ArapUpload,
          meta: { requiresClientSelection: true, title: 'OP bearbeiten' }
        },
        {
          path: 'configuration',
          component: Config,
          meta: { title: 'Konfiguration' }
        },
        {
          path: 'configuration/user',
          component: ConfigUser,
          meta: { requiresAdminPrivileges: true, title: 'Benutzer' }
        },
        {
          path: 'configuration/client',
          component: ConfigClient,
          meta: { title: 'Mandanten' }
        },
        {
          path: 'configuration/client/param/:id',
          component: ConfigClientParam,
          meta: { title: 'Mandanten-Parameter' }
        },
        {
          path: 'configuration/user_client',
          component: ConfigUserClient,
          meta: { title: 'Mandanten zu Benutzer zuweisen' }
        },
        {
          path: 'no_client_selected',
          component: NoClientSelected,
          meta: { title: 'Kein Mandant ausgewählt' }
        }
      ]
    },
    {
      // will match everything
      path: '*',
      component: PageNotFound,
      meta: { requiresAuth: false, title: 'page_not_found' }
    }
  ]
})
  
router.beforeEach((to, from, next) => {
  const appName = 'ICE - '
  
  if (to.meta.hasOwnProperty('requiresAdminPrivileges') && to.meta.requiresAdminPrivileges && store.state.auth.admin !== true) {
	  next(false)
	  return
  }
  
  if (to.meta.hasOwnProperty('requiresClientSelection') && to.meta.requiresClientSelection && store.state.customer.id === 0) {
	  document.title = appName + 'Kein Mandant ausgewählt'
	  next({path: '/home/no_client_selected'})
	  return
  }
  
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.state.auth.valid !== true) {
		document.title = appName + to.meta.title
		next({
			path: '/login',
			query: { redirect: to.fullPath }
		})
    } else {
		document.title = appName + to.meta.title
		next()
    }
  } else {
	document.title = appName + to.meta.title
	next()
  }
})
  
export default router
